import { DateTime } from 'luxon';

export interface TrialInfo {
    isTrialing: boolean;
    daysRemaining: number | null;
    isExpired: boolean;
    trialEndDate: DateTime | null;
    hasPaymentMethod: boolean;
}

export const getTrialInfo = (subscription: any): TrialInfo => {
    if (!subscription || subscription.status !== 'trialing') {
        return {
            isTrialing: false,
            daysRemaining: null,
            isExpired: false,
            trialEndDate: null,
            hasPaymentMethod: subscription?.hasPaymentMethod || false
        };
    }

    if (!subscription.trialEnd) {
        return {
            isTrialing: true,
            daysRemaining: null,
            isExpired: false,
            trialEndDate: null,
            hasPaymentMethod: subscription.hasPaymentMethod || false
        };
    }

    const trialEndDate = DateTime.fromISO(subscription.trialEnd);
    const now = DateTime.now();
    const daysRemaining = Math.ceil(trialEndDate.diff(now, 'days').days);

    return {
        isTrialing: true,
        daysRemaining: daysRemaining > 0 ? daysRemaining : 0,
        isExpired: daysRemaining <= 0,
        trialEndDate,
        hasPaymentMethod: subscription.hasPaymentMethod || false
    };
};

export const getTrialMessage = (trialInfo: TrialInfo): string => {
    if (!trialInfo.isTrialing) {
        return '';
    }

    if (trialInfo.isExpired) {
        return 'Your free trial has expired. Please add a payment method to continue using Levyl.';
    }

    if (trialInfo.daysRemaining === null) {
        return 'You are currently on a free trial.';
    }

    const days = trialInfo.daysRemaining;

    // If user has a payment method, show simpler message
    if (trialInfo.hasPaymentMethod) {
        return `Your free trial expires in ${days} day${
            days === 1 ? '' : 's'
        }.`;
    }

    // If no payment method, encourage them to add one
    return `Your free trial expires in ${days} day${
        days === 1 ? '' : 's'
    }. Add a payment method to continue using Levyl.`;
};
